import "../../styles/footer.css";

export default function Footer() {
  return (
    <footer className="footer">

      <div className="footer__overlay"></div>

      <div className="footer__content">

        <h2 className="footer__logo">
          DEBUTS <span>GROW SHOP</span>
        </h2>

        <p className="footer__subtitle">
          Indoor • Hydro • Grow Technology
        </p>

        <div className="footer__line"></div>

        <p className="footer__copy">
          © 2026 DEBUTS Grow Shop — Todos los derechos reservados
        </p>

      </div>

    </footer>
  );
}